import { evaluate } from "../../data/datastores/evaluations";

export const evaluateContent = async (formData: FormData): Promise<IEvaluation> => {
  const response = await evaluate(formData);
  return response.data;
};
